/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
import { useKeystoneSession } from '../../auth/use-keystone-session';
import { PromotionalItemData, PromotionalSkuData } from '@rta/rta-blueprint-library';
import { useEffect, useState } from 'react';

import { NavType } from '@state';
import { getProducts } from '@external';

// Singleton state outside the component
let promotionalItemDataCache: PromotionalItemData | null = null;
let loadPromise: Promise<PromotionalItemData> | null = null;

export const useLoadPromotionData = (): PromotionalItemData | null => {
	const { getToken, status } = useKeystoneSession();
	const isAuthenticated = status === 'ready';

	const [promotionalItemData, setPromotionalItemData] = useState<PromotionalItemData | null>(promotionalItemDataCache);

	useEffect(() => {
		if (!isAuthenticated) return;

		if (promotionalItemDataCache) {
			return;
		}

		if (loadPromise) {
			loadPromise.then(setPromotionalItemData);
			return;
		}

		loadPromise = (async () => {
			try {
				const promotionalData = await getProducts<Record<string, PromotionalSkuData>>({
					fileName: 'promotions-item-data',
					getToken,
					setError: (error) => console.error('Error loading accessories:', error)
				});

				promotionalItemDataCache = PromotionalItemData.getInstance({
					callback: () => (promotionalData || {})
				});

				console.log('Loaded accessories:');
				return promotionalItemDataCache;
			} catch (error) {
				console.error('Failed to load accessories data:', error);
				promotionalItemDataCache = PromotionalItemData.getInstance({
					callback: () => ({})
				});
				return promotionalItemDataCache;
			}
		})();

		loadPromise.then(setPromotionalItemData);
	}, [isAuthenticated]);

	return promotionalItemData;
};
